<template>
  <div style="margin-top: -10px;">
    <v-btn large :width="width" :height="height">{{label}}</v-btn>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      required: true,
    },
    width: {
      type: String,
      default: '150px',
    },
    height: {
      type: String,
      default: '35px',
    },
  },
  name: 'SubmitButton',
};
</script>

<style lang="scss" scoped>
  @import "src/assets/css/variables.scss";
  .theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined){
    background-color: $submit-color;
    color: white;
    display:block;
    border-radius: 20px;
    border: 1px solid $submit-color;
    margin-top: $margin-button;
    height: $height-button;
  }
</style>
